import { _DICC_GRUPO } from "../../../../data/modulo/Grupo";
import { ISearchProvider, ISearchResult } from "../../../../ui/components-lit/GlobalSearch/types";
import { TGlobalSearchProviderContext } from "./provider.types";

export const createGrupoProvider = (ctx: TGlobalSearchProviderContext): ISearchProvider => {
    return {
        key: "grupo",
        label: "Grupos",
        subLabel: "Gestión de grupos escolares",
        action: ctx.navigateModule("escuelas/grupos"),
        search: (query: string): ISearchResult[] => {
            const category = "Grupos";

            return Array.from(_DICC_GRUPO.values())
                .filter((grupo) => {
                    const groupName = grupo.Nombre || "";
                    const idValue = String(grupo.IdGrupo);
                    return ctx.filter(query, idValue, [groupName, category]);
                })
                .map<ISearchResult>((grupo) => ({
                    id: `grupo-${grupo.IdGrupo}`,
                    title: grupo.Nombre || `Grupo ${grupo.IdGrupo}`,
                    subtitle: `ID ${grupo.IdGrupo}`,
                    category,
                    action: ctx.navigatePanel("escuelas/grupos/panel", grupo.IdGrupo),
                    children: [
                        {
                            id: `grupo-${grupo.IdGrupo}-infogeneral`,
                            title: "Información general",
                            category: "Datos",
                            action: ctx.navigatePanel("escuelas/grupos/panel", grupo.IdGrupo, "pgrupoinfogeneral"),
                        },
                        {
                            id: `grupo-${grupo.IdGrupo}-horariooperacion`,
                            title: "Horario de operación",
                            category: "Datos",
                            action: ctx.navigatePanel("escuelas/grupos/panel", grupo.IdGrupo, "pgrupohorariooperacion"),
                        },
                        {
                            id: `grupo-${grupo.IdGrupo}-maestros`,
                            title: "Maestros asignados",
                            category: "Datos",
                            action: ctx.navigatePanel("escuelas/grupos/panel", grupo.IdGrupo, "pgruposmaestros"),
                        },
                        {
                            id: `grupo-${grupo.IdGrupo}-alumnos`,
                            title: "Alumnos asignados",
                            category: "Datos",
                            action: ctx.navigatePanel("escuelas/grupos/panel", grupo.IdGrupo, "pgrupoalumnos"),
                        },
                    ],
                }));
        },
    };
};
